import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


// Tipos de origen válidos:
// Tipo de creación del pedido (M Manual, I Importado) 


@Pipe({
  name: 'pedidoExternoTipo'
})
export class PedidoExternoTipoPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: unknown): SafeHtml {
    let label = '';
    let cssClass = '';
    let icon = '';
    let strong = false;

    switch (String(value)) {
      case 'M':
        label = 'Creado manualmente';
        cssClass = 'badge-estado-info';
        icon = '<i class="fa-solid fa-laptop me-1"></i>';
        break;
      case 'I':
        label = 'Importado desde fichero externo';
        cssClass = 'badge-estado-success';
        break;
      default:
        return this.sanitizer.bypassSecurityTrustHtml(String(value));
    }

    const text = strong ? `<strong>${label}</strong>` : label;
    const html = `<span class="badge ${cssClass}">${icon} ${text}</span>`;

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
